// extracted by mini-css-extract-plugin
module.exports = {"copy":"components-base-Copy-Copy__copy--1nzy8"};